export enum UniformItemTypes {
  Top = "TOP",
  Bottom = "BOTTOM",
  GoalkeeperTop = "GOALKEEPER_TOP",
  GoalkeeperBottom = "GOALKEEPER_BOTTOM",
  Socks = "SOCKS",
  WarmUpTop = "WARMUP_TOP",
  WarmUpBottom = "WARMUP_BOTTOM",
}
